import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const Checkbox = forwardRef((props, ref) => {
  const {
    name,
    value,
    label,
    checked = false,
    className,
    onChange,
    ...rest
  } = props;
  const componentClassName = "sal-checkbox";
  const classNames = classnames(componentClassName, className, {
    [`${componentClassName}--active`]: checked,
  });

  return (
    <label className={classNames}>
      <input
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        ref={ref}
        {...rest}
      />
      {label}
    </label>
  );
});

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.node,
  checked: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

Checkbox.displayName = "Checkbox";
export default Checkbox;
